// extracted by mini-css-extract-plugin
export default {"container":"ht1wY","titleDefault":"Mp2MJ","titleLarge":"_mgZc","titleBold":"EZJDY","content":"ZS15u","contentNoPadding":"weRx5"};